export const FETCH_WEB_CONFIG = "FETCH_WEB_CONFIG";
export const FETCH_WEB_CONFIG_PENDING = "FETCH_WEB_CONFIG_PENDING";
export const FETCH_WEB_CONFIG_REJECTED = "FETCH_WEB_CONFIG_REJECTED";
export const FETCH_WEB_CONFIG_FULFILLED = "FETCH_WEB_CONFIG_FULFILLED";
